export const IconChevronBulk = ({ style, className }) => {
  return (
    <svg
      style={style}
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path opacity="0.4" d="M15.9998 29.3334C23.3636 29.3334 29.3332 23.3638 29.3332 16C29.3332 8.63622 23.3636 2.66669 15.9998 2.66669C8.63604 2.66669 2.6665 8.63622 2.6665 16C2.6665 23.3638 8.63604 29.3334 15.9998 29.3334Z"/>
      <path d="M20.7069 18.68C20.4535 18.68 20.2002 18.5867 20.0002 18.3867L16.0002 14.3867L12.0002 18.3867C11.6135 18.7734 10.9735 18.7734 10.5869 18.3867C10.2002 18 10.2002 17.36 10.5869 16.9734L15.2935 12.2667C15.6802 11.88 16.3202 11.88 16.7069 12.2667L21.4135 16.9734C21.8002 17.36 21.8002 18 21.4135 18.3867C21.2135 18.5867 20.9602 18.68 20.7069 18.68Z"/>
    </svg>
  );
};